import React, { Component } from 'react';
import Select from 'react-select';

const pad = value => {
  value = String(value);
  while (value.length < 2) {
    value = '0' + value;
  }
  return value;
};

class TimePicker extends Component {
  handleChange = selectedOption => {
    this.props.onChange(selectedOption.value);
  };

  render = () => {
    const options = [];
    const timeOpt = ['AM', 'PM'];
    const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    for (let time in timeOpt) {
      for (let hourIndex in hours) {
        let hour = hours[hourIndex];
        for (let minutes = 0; minutes < 60; minutes += 15) {
          let option = `${pad(hour)}:${pad(minutes)} ${timeOpt[time]}`;
          let optionVal =
            timeOpt[time] === 'PM'
              ? `${pad(hour === 12 ? 12 : hour + 12)}:${pad(minutes)}`
              : `${pad(hour % 12)}:${pad(minutes)}`;
          options.push({ label: option, value: optionVal });
        }
      }
    }

    const selectedIndex = options.findIndex(l => {
      return l.value === this.props.value;
    });
    return (
      <React.Fragment>
        <Select
          value={options[selectedIndex]}
          onChange={this.handleChange}
          openMenuOnFocus={true}
          options={options}
          className={'js-select text-left'}
          isSearchable={false}
          ref={this.props.reference}
        />
      </React.Fragment>
    );
  };
}

export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/TimePicker/TimePicker.jsx